import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '../services/auth.service';
import { TokenStore } from './token-store';

/** Sem sessão não entra no dashboard; tenta refresh silencioso antes de negar. */
export const authGuard: CanActivateFn = async (_route, state) => {
  const tokens = inject(TokenStore);
  const auth = inject(AuthService);
  const router = inject(Router);

  if (tokens.getAccessToken()) {
    return true;
  }
  if (tokens.getRefreshToken()) {
    try {
      await auth.performTokenRefresh();
      if (tokens.getAccessToken()) {
        return true;
      }
      tokens.clear();
    } catch {
      // sessão inválida; cai no redirect
    }
  }
  return router.createUrlTree(['/auth'], { queryParams: { returnUrl: state.url } });
};

/** Sessão ativa não volta para a tela de login. */
export const guestGuard: CanActivateFn = () => {
  const tokens = inject(TokenStore);
  const router = inject(Router);
  if (tokens.getAccessToken() || tokens.getRefreshToken()) {
    return router.createUrlTree(['/dashboard']);
  }
  return true;
};
